import { SWITCH_THEME } from "./constants";

export const switchTheme = () => {
  return {
    type: SWITCH_THEME
  };
};
